import { useContext } from "react";
import { SiteAndGroupTreeContext } from "./SiteAndGroupTreeContext";

const useSiteAndGroupTreeContext = () => {
  return useContext(SiteAndGroupTreeContext);
};

export default useSiteAndGroupTreeContext;
